<template>
  <v-card style="min-height:100%; padding: 0px;">
    <v-card-title class="justify-center">
      <h3 style="padding: 0px; padding-top: 1rem">Transaction Calculation Example</h3>
    </v-card-title>
    <v-card-text>
      <v-divider />
      <v-container fluid align-start>
        <h4 align="center">Calculation Parameters</h4>
        <v-layout row wrap justify-center>
          <v-layout xs7 justify-left>Special Tax Regimen:</v-layout>
          <v-layout xs5 justify-end>{{ regimen }}</v-layout>
        </v-layout>
        <v-layout row wrap>
          <v-layout xs7 justify-left>Tax Calculation Method:</v-layout>
          <v-layout xs5 justify-end>{{ computation }}</v-layout>
        </v-layout>
        <v-layout row wrap>
          <v-layout xs7 justify-left>Example Sale Amount:</v-layout>
          <v-layout xs5 justify-end>{{ exampleSale }}</v-layout>
        </v-layout>
        <v-layout row wrap>
          <v-layout xs7 justify-left>Example Delivery Fee:</v-layout>
          <v-layout xs5 justify-end>{{ exampleDelivery }}</v-layout>
        </v-layout>
        <v-divider />
        <h4 align="center">Calculation</h4>
        <template v-for="tax in taxes">
          <v-layout row wrap :key="tax.id">
            <v-layout xs7 justify-left>{{tax.name}}:</v-layout>
            <v-layout xs5 justify-end>{{tax.amt}}</v-layout>
          </v-layout>
        </template>
        <v-divider />
        <v-layout row wrap>
          <v-layout xs7 justify-left>Transaction Total:</v-layout>
          <v-layout xs5 justify-end>$ {{ total }}</v-layout>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { sync } from "vuex-pathify";
// import axios from "axios";
import axiosInstances from '@/../../coreui/server/axiosInstances'
export default {
  data() {
    return {
      regimen: "",
      computation: "",
      taxes: [],
      rateData: [],
      taxStyle: null,
      rateOBJ: null,
      total: "0.00",
      exampleSale: null,
      exampleDelivery: null,
      saleValue: 100.0,
      deliveryValue: 5.0,
      weightValue: 1
    };
  },
  computed: {
    topItems: sync("savedDialogState"),
    rows: sync("tableRows")
  },
  watch: {
    rows: {
      handler(newValue) {
        console.log("Change in tax rows");
        console.log("Tax Row Count = ", this.rows.length);
        if (this.rows.length == 0) {
          this.taxStyle = null;
          this.total = "0.00";
          this.exampleSale = "N/A";
          this.exampleDelivery = "N/A";
        }
        this.exampleComputation();
      },
      deep: true
    }
  },
  methods: {
    isNull(arg) {
      return arg === null;
    },
    isUndefined(arg) {
      return arg === undefined;
    },
    isEmptyString(arg) {
      if (!this.isNull(arg) && !this.isUndefined(arg)) {
        let testString = String(arg);
        return !testString.trim();
      }
      return false;
    },
    exampleComputation() {
      let simple = false;
      let specialRegimen = false;
      if (this.computation === "Simple") simple = true;
      if (this.checkSpecialRegimen()) specialRegimen = true;
      let length = this.rows.length;
      this.taxes.length = 0;
      let localTotal = 0.0;
      let startLocal = 0.0;
      let j = 0;
      let addDelivery = false;

      // Loop over all of the rates
      for (let i = 0; i < length; i++) {
        const [
          rateCheck,
          rateStyleCheck,
          name,
          unit,
          rate
        ] = this.getTaxParameters(i);
        let currentAmt = 0.0;
        if (rateCheck && rateStyleCheck) {
          if (unit === "%") {
            if (i === 0) {
              this.exampleSale = "$ " + this.saleValue.toFixed(2);
              this.exampleDelivery = "$ " + this.deliveryValue.toFixed(2);
              localTotal = this.saleValue;
              this.taxes.push({
                id: j,
                name: "Subtotal",
                amt: "$ " + this.saleValue.toFixed(2)
              });
            }
          } else {
            this.exampleSale = this.weightValue.toFixed(2) + " lbs";
            this.exampleDelivery = "$ " + this.deliveryValue.toFixed(2);
          }
          if (!specialRegimen) {
            addDelivery = true;
            if (simple) {
              j = j + i + 1;
              if (unit === "%") {
                currentAmt = this.saleValue * (rate / 100);
              } else {
                currentAmt = this.weightValue * 16 * rate;
              }
              localTotal = localTotal + currentAmt;
              this.taxes.push({
                id: j,
                name: name,
                amt: "$ " + currentAmt.toFixed(2)
              });
            } else {
              currentAmt = localTotal * (rate / 100);
              localTotal = localTotal + currentAmt;
              j = j + 2 * i + 1;
              this.taxes.push({
                id: j,
                name: name,
                amt: "$ " + currentAmt.toFixed(2)
              });
              if (i != length - 1) {
                j = j + 2 * i + 1;
                this.taxes.push({
                  id: j,
                  name: "Subtotal",
                  amt: "$ " + localTotal.toFixed(2)
                });
              }
            }
          } else {
            if (i === 0) localTotal = this.saleValue;
            if (this.regimen === "CA Nonarm's Length") {
              [localTotal, j] = this.caNonArmTax(localTotal, name, rate, j);
            } else {
              [localTotal, j] = this.caArmTax(localTotal, name, rate, j)
            }
            if (i != length - 1) {
              j = j + 2 * i + 1;
              this.taxes.push({
                id: j,
                name: "Subtotal",
                amt: "$ " + localTotal.toFixed(2)
              });
            }
          }
        }
      }
      // Check if delivery should be added to the table values
      if (addDelivery) {
        this.taxes.push({
          id: j + 1,
          name: "Delivery Fee",
          amt: "$ " + this.deliveryValue.toFixed(2)
        });
      }
      // Sum up the total for the transaction
      let finalTotal = 0.0;
      if (addDelivery) {
        finalTotal = localTotal + this.deliveryValue;
      } else {
        finalTotal = localTotal;
      }
      this.total = finalTotal.toFixed(2);
    },
    caArmTax(localTotal, name, rate, j){
      console.log("******** Computing ARM Tax")
      console.log("Name = ", name)
      let amt = localTotal
      if (name === "Cannabis Excise Tax"){
        this.taxes.push({
          id: j + 1,
          name: "Delivery Fee",
          amt: "$ " + this.deliveryValue.toFixed(2)
        })
        amt = amt + this.deliveryValue
        this.taxes.push({
          id: j + 2,
          name: "Subtotal (wholesale cost)",
          amt: "$ " + amt.toFixed(2)
        })
        let markup = amt * (this.getCAMarkup() / 100)
        this.taxes.push({
          id: j + 3,
          name: "CA Markup (used in Excise Tax Computation)",
          amt: "$ " + markup.toFixed(2)
        })
        let marketPrice = amt + markup
        this.taxes.push({
          id: j + 4,
          name: "Average market price (used in Excise Tax Computation)",
          amt: "$ " + marketPrice.toFixed(2)
        })
        let exciseTax = marketPrice * (rate / 100)
        let updateTotal = amt + exciseTax
        this.taxes.push({
          id: j + 5,
          name: name,
          amt: "$ " + exciseTax.toFixed(2)
        })
        return [updateTotal, j+5]
      }
      else {
        amt = localTotal * (rate / 100);
        this.taxes.push({
          id: j + 1,
          name: name,
          amt: "$ " + amt.toFixed(2)
        })
        let updateTotal = localTotal + amt
        return [updateTotal, j + 1]
      }

    },
    caNonArmTax(localTotal, name, rate, j) {
      let amt = localTotal * (rate / 100);
      if (name === "Cannabis Business Tax") {
        let updateTotal = localTotal + amt + this.deliveryValue;
        this.taxes.push({
          id: j + 1,
          name: name,
          amt: "$ " + amt.toFixed(2)
        });
        this.taxes.push({
          id: j + 2,
          name: "Delivery Fee",
          amt: "$ " + this.deliveryValue.toFixed(2)
        });
        return [updateTotal, j + 2];
      } else {
        this.taxes.push({
          id: j + 1,
          name: name,
          amt: "$ " + amt.toFixed(2)
        })
        let updateTotal = localTotal + amt
        return [updateTotal, j + 1]
      }
    },
    getCAMarkup() {
      this.rateOBJ = this.rateData.find(x => x["name"] === "CDFTA Markup")
      let rate = null
      if(!this.isUndefined(this.rateOBJ)){
        rate = this.getRate()
      }
      return rate
    },
    getTaxParameters(i) {
      let rateCheck = false;
      let rateStyleCheck = false;
      let name = null;
      let unit = null;
      let rate = null;

      if (!this.isEmptyString(this.rows[i].name)) {
        this.rateOBJ = this.rateData.find(x => x["_id"] === this.rows[i].name);
        if (!this.isUndefined(this.rateOBJ)) {
          rateCheck = true;
          unit = this.getUnit();
          rate = this.getRate();
          name = this.getName();
          if (this.isNull(this.taxStyle)) {
            this.taxStyle = unit;
            rateStyleCheck = true;
          } else {
            if (this.taxStyle != unit) {
              console.log("Error mixing taxes with different units");
              rateStyleCheck = false;
            } else {
              rateStyleCheck = true;
            }
          }
        }
      }
      return [rateCheck, rateStyleCheck, name, unit, rate];
    },
    async fetchData() {
      let temp = await axiosInstances.apiServer.get("/dt/v1/set_tax");
      this.rateData = temp.data;
    },
    getRate() {
      if (
        !this.isUndefined(this.rateOBJ.rate) &&
        !this.isEmptyString(this.rateOBJ.rate)
      ) {
        return parseFloat(this.rateOBJ.rate);
      } else return 0.0;
    },
    getUnit() {
      if (
        !this.isUndefined(this.rateOBJ.unit) &&
        !this.isEmptyString(this.rateOBJ.unit)
      ) {
        return this.rateOBJ.unit;
      } else return "";
    },
    getName() {
      if (
        !this.isUndefined(this.rateOBJ.name) &&
        !this.isEmptyString(this.rateOBJ.name)
      ) {
        return this.rateOBJ.name;
      } else return "";
    },
    checkSpecialRegimen() {
      if (this.regimen != "None") return true;
      else return false;
    }
  },
  mounted() {
    if (this.isNull(this.topItems)) {
      this.regimen = "None";
      this.computation = "Simple";
    } else {
      this.regimen = this.isEmptyString(this.topItems.dialogEditedItem.cond)
        ? "None"
        : this.topItems.dialogEditedItem.cond;
      this.computation = this.isEmptyString(this.topItems.dialogEditedItem.comp)
        ? "Simple"
        : this.topItems.dialogEditedItem.comp;
    }
    this.fetchData();
  }
};
</script>